import { render, staticRenderFns } from "./PublisherView.vue?vue&type=template&id=585b6a93&"
import script from "./PublisherView.vue?vue&type=script&lang=js&"
export * from "./PublisherView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports